import { Box, Button, Stack, Typography } from '@mui/joy';
import Cookies from 'js-cookie';

export default function NoAccessPage() {
    const handleLogout = () => {
        Cookies.remove('auth_token');
        Cookies.remove('auth_token_employee');
        localStorage.removeItem('active_role');
        window.location.href = '/';
    };

    return (
        <Box sx={{ height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
            <Stack spacing={2} sx={{ maxWidth: 400, textAlign: 'center' }}>
                <Typography level="h3">Нет доступа</Typography>
                <Typography level="body-md" color="neutral">
                    У вашей учётной записи нет активной роли. Обратитесь к администратору.
                </Typography>
                <Button onClick={handleLogout}>Выйти</Button>
            </Stack>
        </Box>
    );
}